<div class="modal-body">
  @if (awbHistory.length === 0) {
    <!-- No data state -->
    <div class="d-flex mb-4 justify-content-between">
      <h5 class="modal-title justify-content-start">AWB History</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
      ></button>
    </div>
    <p>
      AWB history data not found. <b>It could be</b> that you have requested a
      pickup/been picked up by the courier during pickup but
      <b>have not scanned</b> the QR code to start the journey at the branch
      office. Please wait.
    </p>
  } @else {
    <!-- Data state -->
    <div class="sticky-top" style="background-color: white">
      <div class="d-flex mb-4 justify-content-between">
        <h5 class="modal-title justify-content-start">
          AWB History
          @if (shipping === 'JNE') {
            <img
              src="https://storage.googleapis.com/komerce/assets/expedisi/logo-jne.png"
              alt=""
              width="40px"
            />
          }
          @if (shipping === 'SICEPAT') {
            <img
              src="https://storage.googleapis.com/komerce/assets/logo/sicepat.svg"
              alt=""
              width="80px"
            />
          }
          @if (shipping === 'IDEXPRESS') {
            <img
              src="https://storage.googleapis.com/komerce/assets/logo/idexpress.svg"
              alt=""
              width="40px"
            />
          }
          @if (shipping === 'SAP') {
            <img
              src="https://storage.googleapis.com/komerce/assets/svg/sap.svg"
              alt=""
              width="40px"
            />
          }
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"
        ></button>
      </div>
      <div class="divider mb-4"></div>
    </div>
    <div class="p-2 w-90" style="height: 500px; overflow-y: scroll !important">
      @for (awb of awbHistory; track awb.date; let i = $index) {
        <div class="ms-2">
          <div class="d-flex">
            <div class="d-flex flex-column align-items-center">
              <img [src]="iconAwb(awbHistory[i].status)" alt="" />
              @if (i !== awbHistory.length - 1) {
                <img
                  src="https://storage.googleapis.com/komerce/assets/illustration/Line-Ticketing.svg"
                  alt=""
                  height="70px"
                />
              }
            </div>
            <div class="ms-3">
              <span
                >{{ awbHistory[i].date | date : "dd MMMM yyyy" }} -
                {{ awbHistory[i].date.slice(10) }}</span
              >
              <br />
              <strong style="color: rgb(84, 84, 84)">{{
                awbHistory[i].desc | uppercase
              }}</strong>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
